import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BannerImage from "../../images/banner_new_img.png";
import MobileBannerImage from "../../images/banner-image-mobile.png";
import TickIcon from "../../images/tick-icon.png";
import PurpleBar from "../../images/purple_bar.svg";
import SearchInput from "../searchInput/SearchInput";
import { MapPinIcon } from "@heroicons/react/24/outline";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useGetProfessionsQuery } from "../../store/professions";
import { toast } from "react-toastify";
import { getQuestionnairres } from "../../store/services/questions.service";
import ReactGA from "react-ga4";
import { handleEventAnalytics } from "../../utilities/eventAnalytics";
import { trackCustomEvent } from "../../FacebookPixel";
import PopularProfessionsSkeleton from "../commons/Skeleton/PopularProfessionsSkeleton";

const Banner = ({ selectedProfessionId, setSelectedProfessionId,onMouseDown }) => {
  const [searchInputValue, setSearchInputValue] = useState("");
  const [zipCodeValue, setZipCodeValue] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const { data: professionsData } = useGetProfessionsQuery();

  const professionsDivisionList = professionsData ?? [];

  const navigate = useNavigate();

  const isMobile =
    window.matchMedia &&
    window.matchMedia("only screen and (max-width: 1023px)").matches;

  useEffect(() => {
    if (selectedProfessionId) {
      const selectedProfession = professionsData?.find(
        (profession) => profession.id === selectedProfessionId
      );
      setSearchInputValue(selectedProfession?.name ?? "");
      setSelectedProfessionId(null);
    }
  }, [selectedProfessionId]);

  const handleSearchInputChange = (value) => {
    setSearchInputValue(value);
    updateButtonState(value, zipCodeValue);
  };

  const updateButtonState = (searchValue, zipValue) => {
    if (zipCodeValue === "") {
      setIsButtonEnabled(false);
    }
    const isInputsFilled = searchValue.trim() !== "" && zipValue.trim() !== "";
    setIsButtonEnabled(isInputsFilled);
  };

 const getOrSetFlowVariant = ()=> {
  let variant = sessionStorage.getItem('flowVariant');
  if (!variant) {
    variant = Math.random() < 0.5 ? 'V2' : 'V3';
    // sessionStorage.setItem('flowVariant', variant);
  }
  return variant;
}

  const handleMatchFlow = async () => {
    const found = professionsDivisionList?.find(
      (profession) =>
        searchInputValue.toLowerCase() === profession.name.toLowerCase()
    );
    formik.handleSubmit();
    if (formik.isValid && found) {
    let professionName = found.name
      if(found.name ==  "Psychiatrist / PMHNP")
      {
        professionName = "psychiatric-provider"
      }
      ReactGA.event(handleEventAnalytics("match_lead"));
      trackCustomEvent("Home Lead Match Start", {});
      const questionnairesResult = await getQuestionnairres(found.id);
      
      if(getOrSetFlowVariant() == "V3" && found.name === "Mental Health Counselor")
      {
        let data = {
          location_id: formik.values.zipCodeValue,
          professionName: searchInputValue,
          questionnaires: questionnairesResult,
          professionId: found.id,
          originUrl: window.location.href,
        }
        localStorage.setItem("leadFlowData", JSON.stringify(data));
        navigate(
          `${professionName.toLowerCase().replace(/\s/g, "-")}/care-options`,
          {
            state: {data},
          }
        );
      }
      else 
      {
        navigate(
          `${professionName.toLowerCase().replace(/\s/g, "-")}/patient/services`,
          {
            state: {
              zipCode: formik.values.zipCodeValue,
              profession: searchInputValue,
              questionnairesResult: questionnairesResult,
              professionId: found.id,
              originUrl: window.location.href,
            },
          }
        );
      }
    } else {
      toast.error("Profession Not Found.");
    }
  };

  const validationSchema = Yup.object().shape({
    zipCodeValue: Yup.string().matches(
      /^[0-9]{1,5}$/,
      "Please type a 5-digit numerical ZIP code location."
    ),
  });

  const formik = useFormik({
    initialValues: {
      zipCodeValue: "",
    },
    validationSchema,
    onSubmit: (values) => {},
  });

  const handleZipCode = (e) => {
    const zipCodeValue = e.target.value;
    if (zipCodeValue.length < 6) {
      setZipCodeValue(zipCodeValue);
      formik.handleChange(e);
    }

    if (formik.errors.zipCodeValue) {
      console.log(
        "There are errors in the zip code field:",
        formik.errors.zipCodeValue
      );
    } else {
      if (zipCodeValue.length === 5) {
        updateButtonState(searchInputValue, zipCodeValue);
      } else {
        setIsButtonEnabled(false);
      }
    }
  };

  return (
    <div
      className="relative pt-[90px] sm:pt-[144px] md:pt-[150px] xl:pt-[190px] pb-[450px] lg:pb-[80px] xl:pb-[140px] bg-[#F9FBFF] overflow-hidden"
      id="banner"
      onMouseDown={onMouseDown()}
    >
      <div className="w-[295px] h-[295px] rounded-[296px] bg-[#DCEEFF] blur-[107px] absolute -left-[133px] top-[126px]"></div>
      <div className="w-[295px] h-[295px] rounded-[296px] bg-[#EBDFFB] blur-[107px] absolute -right-[163px] bottom-[161px]"></div>
      <div className="container mx-auto">
        <div className="flex items-center justify-between">
          <div className="lg:max-w-[650px] xl:max-w-[725px] w-full relative z-[2]">
            <h1 className="text-customGray text-[36px] xl:text-[44px] leading-[130%] xl:leading-[60px] text-center lg:text-left font-bold lg:mb-[60px] md:mb-10 mb-5 max-w-[550px] lg:max-w-none mx-auto lg:mx-0">
              <span className="text-lg md:text-2xl lg:text-[36px] text-customGray font-normal">
                Get Matched with a Local
              </span>
              <br /> Top-Rated
              <span className="text-dotColor1"> Healthcare Provider</span>
              {!isMobile && <br />} in Less Than{" "}
              <span className="relative">
                Two Minutes{" "}
                <img
                  src={PurpleBar}
                  alt="bar"
                  className="absolute left-0 bottom-0 w-full"
                />
              </span>
            </h1>
            <p className="text-customGray lg:text-lg xl:text-[22px] text-base text-center lg:text-left font-normal leading-[160%] mb-1 md:mb-5">
              Just Tell Us What Kind of Provider You Need:
            </p>
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-5 lg:flex items-center h-[70px] rounded-[10px] lg:max-w-full max-w-[600px] hidden">
                <div className="grid grid-cols-4 items-center max-w-[722px] w-full border border-solid border-primary border-r-0 rounded-tl-[10px] rounded-bl-[10px] h-full bg-white">
                  <SearchInput
                    listData={professionsDivisionList}
                    onInputChange={handleSearchInputChange}
                    value={searchInputValue}
                    placeHolder="Dentist, Mental Health, Chiropractor, etc."
                    classes="md:text-base xl:text-lg text-sm font-normal text-[#5C6772] pl-[14px] pr-[14px] border-solid border-[#CCD0D4] border-r bg-transparent rounded-none shadow-none"
                  />
                  <div className="relative dark-field">
                    {/* <MapPinIcon className="absolute w-6 h-6 left-2 top-1/2 transform -translate-y-1/2 text-[#485868]" /> */}
                    <input
                      type="text"
                      placeholder="ZIP Code"
                      className="col-span-1 border-r-0 xl:text-lg text-sm font-normal text-[#5C6772] p-[14px] bg-transparent"
                      name="zipCodeValue"
                      value={formik.values.zipCodeValue}
                       onPaste={(e) => e.preventDefault()}
                      onChange={(e) => handleZipCode(e)}
                      onBlur={formik.handleBlur}
                      onKeyPress={(event) => {
                        const regex = /^[0-9]+$/;
                        const key = String.fromCharCode(
                          !event.charCode ? event.which : event.charCode
                        );
                        if (!regex.test(key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    {formik.touched.zipCodeValue &&
                      formik.errors.zipCodeValue && (
                        <div className="text-xs font-bold text-center text-red-500 absolute -bottom-[75px] right-0">
                          {formik.errors.zipCodeValue}
                        </div>
                      )}
                  </div>
                </div>
                <button
                  className="text-white lg:text-lg text-base font-black leading-[160%] px-4 h-full border-none bg-primary max-w-[191px] w-full duration-500 hover:bg-[#026ed6] rounded-tr-[10px] rounded-br-[10px] capitalize"
                  type="button"
                  onClick={handleMatchFlow}
                  disabled={!isButtonEnabled}
                  style={!isButtonEnabled ? { cursor: "not-allowed" } : {}}
                >
                  get matched now
                </button>
              </div>
            </form>
            <div className="lg:flex items-start gap-2 hidden">
              <span className="text-customGray text-xl font-medium">
                Popular:
              </span>
              <ul className="flex flex-wrap items-center gap-1 mt-0.5">
                {professionsDivisionList.length>0?professionsDivisionList
                  ?.filter((profession) => profession.popular === 1)
                  .map((profession, index) => {
                    return (
                      <li key={index}>
                        <Link
                          to="/"
                          onClick={() =>
                            handleSearchInputChange(profession.name)
                          }
                          className="text-primary text-[18px] leading-[130%] font-medium"
                        >
                          {profession.name}
                          {index !==
                          professionsDivisionList?.filter(
                            (prof) => prof.popular === 1
                          ).length -
                            1
                            ? ", "
                            : " "}
                        </Link>
                      </li>
                    );
                  }):<PopularProfessionsSkeleton/>}
              </ul>
            </div>
            <div className="form-group lg:hidden block max-w-[335px] mx-auto">
              <SearchInput
                listData={professionsDivisionList}
                onInputChange={handleSearchInputChange}
                value={searchInputValue}
                placeHolder="Dentist, Mental Health, Chiropractor, etc."
                classes="text-sm font-medium text-[#5C6772] pl-[14px] pr-[25px] border-solid border-strokeColor rounded-[10px] border h-[50px] mb-1"
              />
              <div className="flex items-start gap-2 mb-5 ml-[14px]">
                <span className="text-customGray text-xs font-medium leading-[160%] mt-1">
                  Popular:
                </span>
                <ul className="flex flex-wrap items-center gap-1">
                  {professionsDivisionList.length>0?professionsDivisionList
                    ?.filter((profession) => profession.popular === 1)
                    .map((profession, index) => {
                      return (
                        <li key={index} className="leading-[130%]">
                          <Link
                            to="/"
                            onClick={() =>
                              handleSearchInputChange(profession.name)
                            }
                            className="text-primary text-xs leading-[130%] font-medium"
                          >
                            {profession.name}
                            {index !==
                            professionsDivisionList?.filter(
                              (prof) => prof.popular === 1
                            ).length -
                              1
                              ? ", "
                              : ""}
                          </Link>
                        </li>
                      );
                    }):<PopularProfessionsSkeleton/>}
                </ul>
              </div>
              <div className="relative dark-field">
                <MapPinIcon className="absolute w-6 h-6 left-2 top-1/2 transform -translate-y-1/2 text-[#485868]" />
                <input
                  type="text"
                  placeholder="ZIP Code"
                  className="text-sm font-medium text-[#5C6772] pl-10 pr-[25px] border-solid border-strokeColor border h-[50px] rounded-[10px] mb-[10px]"
                  name="zipCodeValue"
                  value={formik.values.zipCodeValue}
                  onChange={(e) => handleZipCode(e)}
                  onBlur={formik.handleBlur}
                  onKeyPress={(event) => {
                    const regex = /^[0-9]+$/;
                    const key = String.fromCharCode(
                      !event.charCode ? event.which : event.charCode
                    );
                    if (!regex.test(key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </div>
              {formik.touched.zipCodeValue && formik.errors.zipCodeValue && (
                <div className="text-xs font-bold text-red-500 mb-3">
                  {formik.errors.zipCodeValue}
                </div>
              )}
              <button
                className="text-white lg:text-lg text-base font-black leading-[160%] h-full border-none bg-primary w-full py-3 px-[85px] rounded-[10px] capitalize"
                onClick={() => {
                  if (!isButtonEnabled) {
                    toast.error("Profession and Zip code is required.");
                  } else {
                    handleMatchFlow();
                  }
                }}
              >
                get matched now
              </button>
            </div>
          </div>
          <div className="col-right">
            {/* <div className="absolute bottom-0 right-0 w-[46vw] -mr-10 z-[1]">
              <img
                src={BannerImage}
                alt=""
                loading="lazy"
                className="max-w-[400px] md:max-w-[480px] xl:max-w-[620px]"
              />
            </div> */}
            <div className="block lg:hidden absolute bottom-0 right-0 left-0 mx-auto w-full md:w-[57vw] max-w-[400px] md:max-w-full z-[1]">
              <img
                src={BannerImage}
                alt=""
                loading="lazy"
                className="mt-5 max-w-[375px] mx-auto"
              />
            </div>
            <div className="hidden lg:block absolute bottom-0 right-0 w-[46vw] -mr-10 z-[1]">
              <img
                src={BannerImage}
                alt=""
                loading="lazy"
                className="max-w-[400px] md:max-w-[480px] xl:max-w-[620px]"
              />
            </div>
            {/* {isMobile ? (
              <div className="block lg:hidden absolute bottom-0 right-0 left-0 mx-auto w-full md:w-[57vw] max-w-[400px] md:max-w-full z-[1]">
                <img
                  src={BannerImage}
                  alt=""
                  loading="lazy"
                  className="mt-5 max-w-[375px] mx-auto"
                />
              </div>
            ) : (
              <div className="hidden lg:block absolute bottom-0 right-0 w-[46vw] -mr-10 z-[1]">
                <img
                  src={BannerImage}
                  alt=""
                  loading="lazy"
                  className="max-w-[400px] md:max-w-[480px] xl:max-w-[620px]"
                />
              </div>
            )} */}
            {/* <div className="alert-bullet p-3 md:px-5 md:py-4 rounded-[20px] rounded-bt-[5px] flex items-center gap-[10px] max-w-[175px] md:max-w-[280px] w-full mx-[auto] md:mx-[0] bg-bodyColor absolute right-[0] md:right-[9vw] left-[0] md:left-[auto] bottom-[31px] md:bottom-[51px] animate-bounce">
            <div className="col-left w-[37px] md:w-[54px] h-[37px] md:h-[54px] flex items-center justify-center bg-[#E8FFF5] rounded-[12px]">
              <img src={TickIcon} alt="" />
            </div>
            <div className="max-w-[calc(100%-47px)] md:max-w-[calc(100%-64px)]">
              {isMobile ? (
                <p className="text-xs md:text-[16px] font-bold leading-[120%] text-customGray">
                  Your perfect match is just two minutes away!
                </p>
              ) : (
                <p className="text-xs md:text-[16px] font-bold leading-[120%] text-customGray">
                  Your perfect match is just two minutes away!
                </p>
              )}
            </div>
          </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
